import React, { ChangeEvent } from "react";
import ControlFeedback from "./ControlFeedback";
import { TextareaControlProps } from "./Types";

const TextareaControl: React.FC<TextareaControlProps> = ({ name, value, disabled, width, validationResults, onChange, onBlur, cols, rows }) => {

    function onControlChange(e: ChangeEvent<HTMLTextAreaElement>) {
        onChange(e.target.value);
    }

    let v = '';
    if (value)
        v = value;

    let isValid = validationResults && validationResults.length > 0 ? false : true;

    if (width === undefined)
        width = '100%';

    return (
        <div style={{ width: width }}>
            <textarea name={name} value={v} disabled={disabled} onChange={onControlChange} onBlur={onBlur} className={'form-control'} rows={rows} cols={cols} />
            <ControlFeedback isValid={isValid} validationResults={validationResults}></ControlFeedback>
        </div>
    );
}
export default TextareaControl;